module.exports = __webpack_public_path__ + "static/media/down-arrow.c799d2ea.svg";